import { useEffect, useState } from "react";
import { useGetSubscriptionsQuery } from "../../services/resourceGroups/subscriptionApi";
import { ISubscription } from "@oqdo/automationapps/Memberships/Subscription";

function usePageSubscriptionsQuery(pageSize: number = 10) {
  const [page, setPage] = useState(0);
  const [subscriptions, setSubscriptions] = useState<ISubscription[]>([]);
  const { data, isSuccess, isLoading, error, isFetching } = useGetSubscriptionsQuery({
    page: page,
    pageSize: pageSize,
  });

  useEffect(() => {
    if (data?.data) {
      setSubscriptions((prev) => [...prev, ...data.data]);
    }
  }, [data]);

  useEffect(() => {
    if (isLoading) {
      setSubscriptions([]);
    }
  }, [isLoading]);
  useEffect(() => {
    if (page === 0) {
      setSubscriptions([]);
    }
  }, [page]);

  return {
    subscriptions: subscriptions,
    isLoading: isLoading,
    isSuccess: isSuccess,
    error: error,
    page: page,
    setPage: setPage,
    total: data?.total ?? 0,
    hasMore: (page + 1) * pageSize < (data?.total ?? 0),
    isFetching: isFetching,
  };
}

export default usePageSubscriptionsQuery;
